import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'BasicButton',
  props: {
    color: { default: "neutral" },
    variant: { default: "solid" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
      'button',
      __props.color ? `button--${__props.color}` : '',
      __props.variant ? `button--${__props.variant}` : '',
    ])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})